import request from '@/utils/request'

export function uploadWordSlimFile(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/word-slim/upload/docx', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000
  })
}

export function deleteWordSlimUpload(uploadId) {
  return request.delete(`/word-slim/upload/${uploadId}`)
}

export function submitWordSlim(data) {
  return request.post('/word-slim/submit', data)
}

export function getWordSlimTasks(params) {
  return request.get('/word-slim/tasks', { params })
}

export function getWordSlimTaskDetail(taskNo) {
  return request.get(`/word-slim/task/${taskNo}/detail`)
}

export function getWordSlimDownloadUrl(taskNo) {
  return request.get(`/word-slim/task/${taskNo}/download-url`)
}

export function deleteWordSlimRecord(taskNo) {
  return request.delete(`/word-slim/tasks/${taskNo}`)
}
